import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { NetworkPoint } from 'src/apis/network-points/types';
import type { NetworkPointsRootRequest } from 'src/apis/network-points/use-network-points-root';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  networkPointsRoot: NetworkPointsRootRequest;
  bundleUuid?: string;
};

type ExecuteProps = {
  url: string;
};

export function useBundleByUuid({ networkPointsRoot, bundleUuid }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<NetworkPoint>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!networkPointsRoot.response || !bundleUuid) return;
    const url = urlTemplate
      .parse(networkPointsRoot.response.data._links.getBundleById.href)
      .expand({ uuid: bundleUuid });
    request.execute({
      url,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [networkPointsRoot.response, bundleUuid]);

  return request;
}
